import PlatformModalLayer from '../../utils/PlatformModalLayer';
import React, { useState, useEffect } from "react";
import Spinner from "../../utils/spinner/Spinner.jsx";
import { toast } from "react-toastify";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import {
    API_ENDPOINT_SAVE_LOGIN_TOKEN
} from "../../../data/Endpoints-API.js";
import APIMiddleware from "../../../data/api/Api-Middleware.js";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import { FaTimes } from "react-icons/fa";
import { formatPrice } from "../../../utils/format.js";
import { Ripple } from "react-ripple-click";
import "./Margin-Call.scss"
import getBackendUrl from "../../utils/RedirectUrl.js";
import { useAccountManagerContext } from "../../../contexts/Account-Manager-Context.js";
import { useChartContext } from "../../../contexts/Chart-Context.js";
import { useTranslation } from "react-i18next";

interface MarginCallProps {
    onCancel: () => void;
  }
  
  const MarginCall: React.FC<MarginCallProps> = ({
    onCancel,
  }) =>  {
    const { t } = useTranslation();
    const {
      user
    } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const { setShowDeposit } = useAccountManagerContext();
   const { selectedStyle } = useChartContext();


    const depositRedirect = (e) => {
      const action = e.target.getAttribute('action');
      if (action == 'exit') {
        e.target.parentNode.parentNode.parentNode.setAttribute('view', false);
      } else{
        e.target.parentNode.parentNode.parentNode.setAttribute('view', false);
        setShowDeposit(true);
      }
    };

    return (
        <PlatformModalLayer className="modal-container">
        <div className="card">
          <div className="model-header">
            <h2>{t('marginCall.title')}</h2>
            <button
              onClick={() => {
                onCancel();
              }}
              className="close-icon"
            >
              <FaTimes />
            </button>
          </div>
          <div className="model-details">
            
            <p className="text-1">{t('marginCall.warning')}</p>
            <p className="text-2">{t('marginCall.depositHint')}</p>
          </div>
  
  
          <div className="row-scss">
            <button
              className="cancel-btn"
              onClick={() => onCancel()}
              style={{ backgroundColor: selectedStyle.sellColor }}
            >
              {t('common.cancel')}
            </button>
            <button
              onClick={(e) => {
                // mkRipple(e);
                depositRedirect(e);
              }}
              action={`${getBackendUrl()}/new_deposit_request`}
              style={{
                position: 'relative',
                overflow: 'hidden',
                isolation: 'isolate',
                backgroundColor: selectedStyle.buyColor,
              }}
            >
              <Ripple />
              {t('orderPanel.deposit')}
            </button>
          </div>
        </div>
      </PlatformModalLayer>
    );
};

export default MarginCall;
